module.exports = __webpack_public_path__ + "img/logo_2022.0bf94f04.png";